import { postItemInfoStyle, postItemRootStyle, postItemTitleStyle, ellipsis } from 'common.styles'

export const postNavLinkRootStyle = theme => ({
  ...postItemRootStyle(theme),
  width: 17 * theme.sizing.mdGridSize,
  maxWidth: '100%'
})

export const postNavLinkInfoStyle = () => ({
  ...postItemInfoStyle(),
  paddingBlock: 3,
  paddingInline: {
    xs: 3.5,
    md: 4
  },
  '.next &': {
    textAlign: 'end'
  }
})

export const postNavLinkTitleStyle = theme => ({
  ...postItemTitleStyle(),
  ...ellipsis,
  fontSize: {
    sm: 'h6.fontSize',
  },
  lineHeight: {
    sm: theme.typography.h6.lineHeight,
  },
  letterSpacing: {
    sm: theme.typography.h6.letterSpacing,
  }
})

export const postNavLinkDirStyle = () => ({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  marginTop: 0.5,
  marginBottom: 2.5,
  lineHeight: 1,
  letterSpacing: 1,
})

export const postNavLinkDirTextStyle = () => ({
  flex: '0 1 100%',
  minWidth: 0,
  ...ellipsis,
})
